import { render, staticRenderFns } from "./m_skill.vue?vue&type=template&id=98ff5b66&scoped=true&"
import script from "./m_skill.vue?vue&type=script&lang=js&"
export * from "./m_skill.vue?vue&type=script&lang=js&"
import style0 from "./m_skill.vue?vue&type=style&index=0&id=98ff5b66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ff5b66",
  null
  
)

export default component.exports